
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { TranslateResult } from "vue-i18n";
import { DashboardBankData } from "@/utils/dashboard/dashboard-bank-data";
import AppMultiSelectBankType from "@/components/bank/MultiSelectBankType.vue";

export default Vue.extend({
	data(){
		return {
			data: new DashboardBankData(),
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data) {
					this.data = new DashboardBankData();
					return;
				}
				this.data = new DashboardBankData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
	},
	components: {
		AppMultiSelectBankType
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
